import { useJsApiLoader } from '@react-google-maps/api';
import { ReactNode, useEffect } from 'react';
import { updateIsLoaded } from './client-redux/map';
import { useDispatch } from 'react-redux';

interface GoogleMapsProviderProps {
  children: ReactNode;
}

export function GoogleMapsProvider({ children }: GoogleMapsProviderProps) {
  const dispatch = useDispatch();

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''
  });

  useEffect(() => {
    dispatch(updateIsLoaded(isLoaded));
  }, [isLoaded, dispatch]);

  if (!isLoaded) {
    return;
  }

  return <>{children}</>;
}
